export default __webpack_public_path__ + "static/media/fi-analytics.1c69bc2e.svg";